"use strict";

// Product-only fast path. This listener owns the main purchase form before the
// deferred theme runtime arrives, preventing delayed or duplicate submissions.
(function () {
	const activeRequests = new WeakMap();

	function getMainProductForm(target) {
		const form = target instanceof HTMLFormElement ? target : null;
		if (!form || !form.matches('#main-product form.f8pr-buy-button')) return null;
		return form;
	}

	function setLoading(form, loading) {
		const button = form.querySelector('button[type="submit"]');
		form.classList.toggle('processing', loading);
		form.setAttribute('aria-busy', loading ? 'true' : 'false');
		if (!button) return;
		button.disabled = loading;
		button.classList.toggle('processing', loading);
	}

	function openPendingDrawer() {
		const cart = document.getElementById('cart');
		if (!cart) return null;
		document.documentElement.classList.add('has-panels', 'm6pn-open', 'a2z-cart-opening');
		cart.classList.add('toggle');
		cart.setAttribute('aria-hidden', 'false');
		let status = cart.querySelector('.a2z-cart-pending-status');
		if (!status) {
			status = document.createElement('p');
			status.className = 'a2z-cart-pending-status';
			status.setAttribute('role', 'status');
			status.textContent = window.translations && window.translations.adding_to_cart
				? window.translations.adding_to_cart
				: 'Adding to cart…';
			cart.prepend(status);
		}
		return status;
	}

	function showError(message) {
		window.dispatchEvent(new CustomEvent('showAlert', {
				detail: {
					message: message || (window.translations && window.translations.cart_add_error) || 'Unable to add this item. Please try again.',
					type: 'error'
				}
		}));
	}

	function renderDrawerFallback(data) {
		const cart = document.getElementById('cart');
		const markup = data && data.sections && data.sections['side-cart'];
		if (!cart || typeof markup !== 'string') return false;
		const parsed = new DOMParser().parseFromString(markup, 'text/html');
		const section = parsed.getElementById('shopify-section-side-cart');
		cart.innerHTML = section ? section.innerHTML : markup;
		return true;
	}

	function handOffToCartRuntime(data) {
		let frames = 0;
		function attempt() {
			if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
				window.ajaxCart.load(data, true);
				document.documentElement.classList.remove('a2z-cart-opening');
				return;
			}
			frames += 1;
			if (frames < 90) {
				window.requestAnimationFrame(attempt);
				return;
			}
			renderDrawerFallback(data);
			document.documentElement.classList.remove('a2z-cart-opening');
		}
		attempt();
	}

	async function addToCart(form) {
		if (activeRequests.has(form)) return;
		const controller = new AbortController();
		activeRequests.set(form, controller);
		setLoading(form, true);
		openPendingDrawer();

		try {
			const payload = new FormData(form);
			payload.set('sections', 'side-cart');
			const response = await fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
				method: 'POST',
				body: payload,
				signal: controller.signal,
				headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
			});
			const data = await response.json();
			if (!response.ok || data.status) throw new Error(data.description || (window.translations && window.translations.cart_add_error));
			handOffToCartRuntime(data);
		} catch (error) {
			if (error.name !== 'AbortError') {
				showError(error.message);
				const status = document.querySelector('#cart .a2z-cart-pending-status');
				if (status) {
					status.classList.add('is-error');
					status.textContent = error.message || (window.translations && window.translations.cart_add_error);
				}
			}
			document.documentElement.classList.remove('a2z-cart-opening');
		} finally {
			activeRequests.delete(form);
			setLoading(form, false);
		}
	}

	document.addEventListener('submit', function (event) {
		const form = getMainProductForm(event.target);
		if (!form) return;
		event.preventDefault();
		event.stopImmediatePropagation();
		addToCart(form);
	}, true);
})();
